// Generated by CoffeeScript 2.7.0
var Deprecation;

if (process.env.NODE_ENV === 'production') {
  Deprecation = class Deprecation {
    static warn(deprecated_method_name, message) {}

  };
} else {
  Deprecation = class Deprecation {
    static warn(deprecated_method_name, message) {
      return console.warn(`[DEPRECATION WARNING]: ${deprecated_method_name} is deprecated | ${message}`);
    }

  };
}

window.Deprecation = Deprecation;
